<template>
  <HomeSection ref="home"></HomeSection>
</template>

<script>
  import HomeSection from "./HomeSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "HomeWrapper",
    components: {
      HomeSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
